export default "__VITE_ASSET__e8346830__"